export const TierBadge = ({ tier }) => {
  const styles = {
    elite: { bg: 'rgba(168, 85, 247, 0.2)', color: '#a855f7', border: '1px solid #a855f7' },
    pro: { bg: 'rgba(59, 130, 246, 0.2)', color: '#3b82f6', border: '1px solid #3b82f6' },
    starter: { bg: 'rgba(34, 197, 94, 0.2)', color: '#22c55e', border: '1px solid #22c55e' }
  };
  const style = styles[tier] || styles.starter;
  
  return (
    <span 
      className="text-xs px-2 py-0.5 rounded-full font-medium"
      style={{ background: style.bg, color: style.color, border: style.border }}
    >
      {tier?.toUpperCase()}
    </span>
  );
};
